'use client';

import Clickable from '@carvana/merch-components/Clickable';
import { useState } from 'react';
import { imageUrl } from '@/vm/Shared/imageUrl';
import ReturnPolicyModal from '@/vm/Shared/modals/ReturnPolicyModal';
import { YellowHorizontal } from '@/vm/Shared/YellowHorizontal.styles';
import Step from './Step';
import { GraphicWrapper, BottomNote, BottomImage } from './Step.styles';
import { Title, TitleWrapper } from '../Shared/Shared.styles';

export default function Steps() {
  const [isReturnPolicyModalOpen, setIsReturnPolicyModalOpen] = useState(false);

  return (
    <>
      <YellowHorizontal />
      <TitleWrapper>
        <Title>What to expect during your visit</Title>
      </TitleWrapper>
      <div className="mx-auto mb-40 mt-80">
        <GraphicWrapper>
          <Step
            labelOne="Insert Your Token"
            imageFilename="insert-coin.png"
            number="1"
            position="left"
          />
          <Step
            labelOne="Watch Your Car"
            labelTwo="Being Retrieved"
            imageFilename="retrieve-vehicle.png"
            number="2"
            position="right"
          />
          <Step
            labelOne="Take It"
            labelTwo="For a Spin"
            imageFilename="test-drive.png"
            number="3"
            position="left"
          />
          <Step
            labelOne="Sign and Drive It"
            imageFilename="drive-home.png"
            number="4"
            position="right"
          />
        </GraphicWrapper>
      </div>
      <BottomNote>
        <BottomImage>
          <img
            alt="Test Own"
            src={imageUrl('test-own.png')}
            width="60px"
            height="60px"
          />
        </BottomImage>
        <div>
          <h3 className="mb-0 text-blue-6">7-Day Money Back Guarantee</h3>
          <p className="text-[#757989]">
            Have peace of mind knowing that you have 7 days to love it or return
            it.
          </p>
          <Clickable
            className="text-blue-2"
            onClick={() => setIsReturnPolicyModalOpen(true)}
            data-analytics-id="Learn More"
            data-testid="learn-more-button"
          >
            Learn More
          </Clickable>
        </div>
      </BottomNote>

      <ReturnPolicyModal
        isOpen={isReturnPolicyModalOpen}
        onClose={() => setIsReturnPolicyModalOpen(false)}
      />
    </>
  );
}
